import { Button, FormControl, IconButton, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from "Global";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import App from "elements/HtmlEditor/App";
import { useSnackbar, withSnackbar } from "notistack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Categorias from "elements/Categorias";

export default withSnackbar(function RitualesEditor(props: any) {
  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */

  /*=======================================
      GET RITUAL ID FROM URL
    =======================================*/
  let { ritual_id, rituales_category_id } = useParams();
  /*=======================================
    =======================================*/

  const navigate = useNavigate();
  const defaultValues: any = {
    ritual_id: ritual_id ? ritual_id : "null",
    rituales_category_id: rituales_category_id ? rituales_category_id : "1",
    lang_id: "1",
    title: "",
    contentHTML: "",
    contentJSON: null,
    image: "",
    file: "",
    filePdf: "",
    file_id: 0,
  };

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);
  const [files, setFiles] = useState<File | null>(null);
  
  // Idiomas disponibles
  interface Lang {
    lang_id: string;
    lang: string;
  }
  const [langs, setLangs] = useState<Lang[]>([]);

  // Cargar idiomas disponibles
  useEffect(() => {
    axios
      .get(ProjectConfig.api_url, { params: { request: "lang_list_simple" } })
      .then((res) => {
        if (Array.isArray(res.data)) {
          setLangs(res.data);
        } else if (res.data.lang_list) {
          setLangs(res.data.lang_list);
        }
      })
      .catch((err) => console.error("Error loading langs:", err));
  }, []);

  interface pdfData {
    file_id: any;
    file: any;
    name: string;
    estado: string;
  }

  const [filesPdf, setFilesPdf] = useState<pdfData[]>([]);

  const handleInputChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  /*=======================================
      TEXT EDITOR
    =======================================*/
  const [initialContent, setInitialContent] = useState<any>(null);

  const handleEditorChange = (htmlContent: any, jsonContent: any) => {
    setFormValues({
      ...formValues,
      contentHTML: htmlContent,
      contentJSON: jsonContent,
    });
  };

  /*=======================================
    =======================================*/

  /*=======================================
      GET DETAILS IF EDITING
    =======================================*/
  useEffect(() => {
    if (ritual_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "rituales_details",
            id: ritual_id,
          },
        })
        .then((response) => {
          setFormValues(response.data);
          setInitialContent(response.data.contentJSON);

          response.data.categorias.map(
            (categoriaNew: Categoria, index1: number) =>
              setCategoriasAll((prevCategorias) => {
                const newCategorias = [...prevCategorias];
                newCategorias[index1] = categoriaNew;
                return newCategorias;
              })
          );
          setFilesPdf(response.data.files);
        })
        .catch((err) => {
          console.log(err.data);
        });
    }
  }, []);
  /*=======================================
    =======================================*/

    interface SubCategoria {
      id: number;
      padre_id: number;
      label: string;
      titulo: string;
      contentJSON: any | null;
      contentJSON_send: any | null;
      contentHTML: string;
      contentHTML_send: string;
      estado: string;
      delete: number;
      orden: number;
    }
  
    interface Categoria {
      id: number;
      label: string;
      titulo: string;
      contentJSON: any | null;
      contentJSON_send: any | null;
      contentHTML: string;
      contentHTML_send: string;
      subCategorias: SubCategoria[];
      estado: string;
      tipo: string;
      delete: number;
    }
  

  /*=======================================
      SUBMIT
    =======================================*/
  const [progress, setProgress] = useState(0);

  const [categoriasAll, setCategoriasAll] = useState<Categoria[]>([]);
  const [categorias_send, setCategorias_send] = useState<Categoria[]>([]);


  const handleSubmit = () => {
    const formData = new FormData();
    
    // Agregar archivo de imagen si existe
    if (files && files instanceof File) {
      formData.append("files", files);
    }
    
    formData.append("formValues", JSON.stringify(formValues));
    formData.append("categorias", JSON.stringify(categorias_send));

    // Agregar archivos PDF al FormData
    for (let i = 0; i < filesPdf.length; i++) {
      formData.append(`filesPdf[${i}][file_id]`, filesPdf[i].file_id);
      formData.append(`filesPdf[${i}][file]`, filesPdf[i].file);
      formData.append(`filesPdf[${i}][name]`, filesPdf[i].name);
      formData.append(`filesPdf[${i}][estado]`, filesPdf[i].estado);
    }

    //AXIOS
    axios
      .post(ProjectConfig.api_url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          setProgress(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
        params: {
          request: "add_edit_rituales",
        },
      })
      .then((response) => {
        if (response.data) {
          navigate(`/admin/ritos/${rituales_category_id}`);
        } else {
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });
  };

  const [ident, setident] = useState(1000000001);

  const borrarPorIdPdf = (file_id: number) => {
    borrar_file(file_id);
    setFilesPdf((prevPdf) =>
      prevPdf.filter((file) => file.file_id !== file_id)
    );
  };

  const borrar_file = (directorio_id: Number) => {
    const formData = new FormData();
    formData.append("archivo_id", JSON.stringify(directorio_id));
    //AXIOS
    axios
      .post(ProjectConfig.api_url, formData, {
        onUploadProgress: (progressEvent) => {
          setProgress(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        },
        params: {
          request: "delete_archivo",
        },
      })
      .then((response) => {
        console.log(response);
        if (response.data) {
          setFormValues({
            ...formValues,
            filePdf: "",
            file_id: 0,
          });
        } else {
          enqueueSnackbar("Error al borrar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
      });
  };

  const add_file = () => {
    setFilesPdf((current) => [
      ...current,
      {
        file_id: ident,
        file: "",
        name: "",
        estado: "nuevo",
      },
    ]);
    setident(ident + 1);
  };

  const handleFileInputChange = (
    file_id: number,
    file: any,
    name: string,
    estado: string
  ) => {
    actualizarFile(file_id, file, name, estado);
  };

  const actualizarFile = (
    file_id: number,
    file: any,
    name: string,
    estado: string
  ) => {
    if (estado == "nuevo") {
      setFilesPdf((prevFile) =>
        prevFile.map((pdfRow) =>
          pdfRow.file_id === file_id
            ? {
                ...pdfRow,
                file: file,
                name: name,
              }
            : pdfRow
        )
      );
    } else {
      setFilesPdf((prevFile) =>
        prevFile.map((pdfRow) =>
          pdfRow.file_id === file_id
            ? {
                ...pdfRow,
                file: file,
                name: name,
                estado: "editable",
              }
            : pdfRow
        )
      );
    }
  };

  const actualizarTituloPorIdPdf = (file_id: any, name: any) => {
    setFilesPdf((prevFile) =>
      prevFile.map((pdfRow) =>
        pdfRow.file_id === file_id
          ? {
              ...pdfRow,
              name: name,
            }
          : pdfRow
      )
    );
  };

  return (
    <div id="userForm">
      <div className="userForm_right">
        <Box
          id="santoral_editor"
          className="box_editor"
          title="Rito"
          subtitle="Editar"
        >
          {/* SELECTOR DE IDIOMA */}
          <FormControl fullWidth style={{ marginBottom: "16px" }}>
            <InputLabel id="lang-select-label">Idioma</InputLabel>
            <Select
              labelId="lang-select-label"
              id="lang_id"
              name="lang_id"
              value={formValues.lang_id || "1"}
              label="Idioma"
              onChange={(e) => setFormValues({ ...formValues, lang_id: e.target.value })}
            >
              {langs.map((lang) => (
                <MenuItem key={lang.lang_id} value={String(lang.lang_id)}>
                  {lang.lang}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div className="input_group">
            <div className="input_group">
              <div className="input_row">
                {/* UPLOAD button with preview */}
                <div className="drawerImagesContainer">
                  <div
                    className="drawerImagesContainerDiv"
                    onDrop={(e) => {
                      e.preventDefault();
                      const files = e.dataTransfer.files;
                      setFiles(files[0]);
                      const fileArray = Array.from(files).map((file: any) =>
                        URL.createObjectURL(file)
                      );
                      setFormValues({
                        ...formValues,
                        image: fileArray[0],
                      });
                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add("dropzone_active");
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                  >
                    {formValues.image && <img src={formValues.image} />}

                    <label
                      id="dropFileDiv"
                      className={formValues.image && "showOnlyOnHover"}
                    >
                      <IconButton
                        aria-label="delete"
                        size="small"
                        className="addFile_button"
                        component="span"
                      >
                        <CameraAltIcon />
                        <input
                          type="file"
                          multiple
                          hidden
                          onChange={(e) => {
                            const files = e.target.files;
                            if (files) {
                              setFiles(files[0]);
                              const fileArray = Array.from(files).map(
                                (file: any) => URL.createObjectURL(file)
                              );
                              setFormValues({
                                ...formValues,
                                image: fileArray[0],
                              });
                            }
                          }}
                        />
                      </IconButton>
                    </label>
                  </div>
                </div>

                <div className="inputColumn">
                  <TextField
                    id="title"
                    name="title"
                    label="Título"
                    type="text"
                    required
                    fullWidth
                    value={formValues.title || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <App
              handleEditorChange={handleEditorChange}
              content={initialContent}
            />

        <Categorias
            categorias={categoriasAll}
            setCategorias_send={setCategorias_send}
          />

    
          </div>

          {/* PDFs */}
          <>
          {filesPdf.length > 0 &&
            filesPdf.map((fileRow, index) => (
              <div key={index}>
                <label>Titulo</label>
                <div className="inputColumn">
                  <input
                    type="text"
                    name={"titulo_" + index}
                    id={"titulo_" + index}
                    onChange={(e) =>
                      actualizarTituloPorIdPdf(fileRow.file_id, e.target.value)
                    }
                    value={fileRow.name}
                  />
                </div>
                <br />
                <div className="drawerImagesContainer">
                  <div
                    id="multimediaFileDropBox"
                    className={
                      "drawerImagesContainerDiv " +
                      (fileRow.file != "" ? "hasFile" : "")
                    }
                    onDrop={(e) => {
                      e.preventDefault();
                      const files = e.dataTransfer.files;
                      const fileName = files[0].name;
                      handleFileInputChange(
                        fileRow.file_id,
                        files[0],
                        fileName,
                        fileRow.estado
                      );

                      const fileArray = Array.from(files).map((file: any) =>
                        URL.createObjectURL(file)
                      );

                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add("dropzone_active");
                    }}
                    onDragLeave={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.remove("dropzone_active");
                    }}
                  >
                    {fileRow.file && (
                      <span className="fileUploaded">
                        <AttachFileIcon />
                        {fileRow.name}
                      </span>
                    )}

                    <label
                      id="dropFileDiv"
                      className={fileRow.file && "showOnlyOnHover"}
                    >
                      <IconButton
                        aria-label="delete"
                        size="small"
                        className="addFile_button"
                        component="span"
                      >
                        <FileUploadIcon />

                        <input
                          type="file"
                          multiple
                          hidden
                          accept=".pdf"
                          onChange={(e) => {
                            const files = e.target.files;
                            if (files) {
                              const fileName = files[0].name;
                              handleFileInputChange(
                                fileRow.file_id,
                                files[0],
                                fileName,
                                fileRow.estado
                              );
                              const fileArray = Array.from(files).map(
                                (file: any) => URL.createObjectURL(file)
                              );
                            }
                          }}
                        />
                      </IconButton>
                      Arrastra aquí un archivo o da click para subirlo.
                    </label>
                  </div>
                  {fileRow.file != "" && (
                    <Button
                      onClick={() => borrarPorIdPdf(fileRow.file_id)}
                      variant="contained"
                      className="button_1"
                    >
                      Borrar
                    </Button>
                  )}
                </div>
              </div>
            ))}

          <>
            <br></br>
            <br></br>
            <Button onClick={add_file} variant="contained" className="button_1">
              Agregar PDF
            </Button>
          </>
          </>

          <div className="buttons">
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              className="button_2"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              className="button_1"
            >
              Guardar
            </Button>
          </div>
        </Box>
      </div>
    </div>
  );
});
